"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Assets = void 0;
const utils_1 = require("./utils");
const cross_fetch_1 = require("cross-fetch");
class Assets {
    constructor(dataServiceUrl = 'https://waves.exchange/api/v1', iconUrl = 'https://waves.exchange/static/icons/assets') {
        this.assets = Object.create(null);
        this._assetsPromise = Object.create(null);
        this.iconUrl = iconUrl;
        this.dataServicesUrl = dataServiceUrl;
    }
    getAssets(assets) {
        return __awaiter(this, void 0, void 0, function* () {
            const assetsToFetch = assets.filter(id => !this.assets[id] || !this._assetsPromise[id]);
            const waitPromises = assets.filter(id => this._assetsPromise[id]).map(id => this._assetsPromise[id].promise);
            while (true) {
                try {
                    const promise = this._fetchAssets(assetsToFetch)
                        .then(assets => {
                        assets.forEach(asset => {
                            this.assets[asset.id] = asset;
                        });
                        return assets;
                    });
                    assetsToFetch.forEach((id, index) => {
                        this._assetsPromise[id] = { promise, index };
                    });
                    yield Promise.all([promise, ...waitPromises]);
                    break;
                }
                catch (e) {
                    yield utils_1.waitPromise(5000);
                }
            }
            return assets.map(id => this.assets[id]);
        });
    }
    _fetchAssets(assets) {
        return cross_fetch_1.default(`${this.dataServicesUrl}/assets`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ids: assets })
        }).then((res) => {
            if (res.status >= 400) {
                throw new Error('Bad response from server');
            }
            return res.text();
        })
            .then(utils_1.parseJSON).then(res => res.data)
            .then(assets => assets.map((item) => utils_1.convertToExtendedAsset(item, this.iconUrl)));
    }
}
exports.Assets = Assets;
